import React from 'react';
import PropTypes from 'prop-types';

const Filter = ({ withFilters, color = '#788590' }) => {
    if (withFilters) {
        return (
            <svg
                width="10px"
                height="10px"
                viewBox="0 0 10 10"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g
                    id="Svg-Icons/10px-(All-icons)/no-scale/filter_active"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <polygon
                        id="Bounds"
                        fillOpacity="0.1"
                        fill="#FF0000"
                        opacity="0"
                        points="0 0 10 0 10 10 0 10"
                    />
                    <path
                        d="M5.5,6.3 L5.5,10 L4.5,10 L4.5,6.3 L0,0 L10,0 L5.5,6.3 Z"
                        id="Combined-Shape"
                        fill="#FF8C00"
                        className="icon-color"
                    />
                </g>
            </svg>
        );
    }
    return (
        <svg
            width="10px"
            height="10px"
            viewBox="0 0 10 10"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                id="Svg-Icons/10px-(All-icons)/no-scale/filter"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <polygon
                    id="Bounds"
                    fillOpacity="0.1"
                    fill="#FF0000"
                    opacity="0"
                    points="0 0 10 0 10 10 0 10"
                />
                <path
                    d="M5.5,6.3 L5.5,10 L4.5,10 L4.5,6.3 L0,0 L10,0 L5.5,6.3 Z M1.94318932,1 L5,5.27953495 L8.05681068,1 L1.94318932,1 Z"
                    id="Combined-Shape"
                    fill={color}
                    className="icon-color"
                />
            </g>
        </svg>
    );
};

Filter.propTypes = {
    withFilters: PropTypes.bool,
    color: PropTypes.string,
};

export default Filter;
